import { NgModule } from '@angular/core';
import { KrakenPanelComponent } from './kraken-panel.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    KrakenPanelComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    KrakenPanelComponent
  ]
})
export class KrakenPanelModule { }
